import { RgChildren as t, getRgObjectsOfType as r } from "@project-rouge/rg-core";
function u(e, l, i) {
  return i = i ?? t.Building, r(e, i).filter((n) => n.data.level === l);
}
export {
  u as getBuildingChildrenAtLevel
};
//# sourceMappingURL=index.js.map
